module.exports = {
  // baseUrl: '/mFitness-api', // nginx转换
  baseUrl: 'https://swim.meizaichen.cn/mFitness-api/', // 正式 
  // baseUrl: 'https://release-swim.meizaichen.cn:3070/mFitness-api/', // 测试 (k8s:release/*)
  // baseUrl: 'https://dev-swim.meizaichen.cn:3070/mFitness-api/', // 开发 (k8s:dev-2024)
  // baseUrl: 'http://192.168.1.63:31034/', // 内网 (k8s:release/*)
  // baseUrl: 'http://192.168.1.63:31033/', // 内网 (k8s:dev-2024)
  // baseUrl: 'http://192.168.1.240:7080/', // 乔
  // imagesUrl: '/imagesUrl' // 图片跨域
}